.features {
  .button {
    width: 100%;
    margin-bottom: 20px;
  }
}

.drawer {
  padding: 20px;
  box-sizing: border-box;
}

.drawerAnchor {
  background: white;
  width: min(100vw, 320px);
  box-sizing: border-box;
  overflow: hidden;
}

.drawerContent {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.featureList {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px;
}

.featureItem {
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.featureLabel {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background: white;
  border-top: 1px solid #ececec;
  font-size: 16px;
}
